import React from 'react';
import Icon from '@components/AppIcon';
import Button from '@components/ui/Button';

const ContactSection = () => {
  const handleBookAppointment = () => {
    window.location.href = '/book-appointment-guided-care-journey';
  };

  const handleCallUs = () => {
    window.location.href = 'tel:+254718202020';
  };

  const handleEmailUs = () => {
    window.location.href = 'mailto:info@eyenu.com';
  };

  const contactOptions = [
    {
      title: 'Call Us',
      desc: 'Speak directly with our team for immediate assistance.',
      icon: 'Phone',
      action: handleCallUs,
      btn: { text: 'Call Now', variant: 'outline' },
    },
    {
      title: 'Email Us',
      desc: "Send us your questions and we'll respond promptly.",
      icon: 'Mail',
      action: handleEmailUs,
      btn: { text: 'Send Email', variant: 'outline' },
    },
    {
      title: 'Book Appointment',
      desc: 'Schedule a consultation to discuss your eye care needs.',
      icon: 'Calendar',
      action: handleBookAppointment,
      btn: { text: 'Book Now', variant: 'default' },
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Heading */}
        <div className="max-w-3xl mx-auto text-center mb-14">
          <h2
            className="text-4xl md:text-5xl font-extrabold mb-4 tracking-tight"
            style={{ color: '#08005f' }}
          >
            Still Have Questions?
          </h2>
          <p className="text-lg md:text-xl text-text-secondary leading-relaxed">
            Can't find the answer you're looking for? Our friendly team is here to help. 
            Get in touch with us directly or schedule an appointment.
          </p>
        </div>

        {/* Contact Options */}
        <div className="grid md:grid-cols-3 gap-8 mb-14">
          {contactOptions.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 text-center border border-[#08005f] border-opacity-10 hover:bg-[#e8eafd] hover:medical-shadow medical-transition"
            >
              {/* Icon */}
              <div className="w-20 h-20 bg-[#08005f]/10 rounded-2xl flex items-center justify-center mx-auto mb-6">
                <Icon name={item.icon} size={28} color="#08005f" strokeWidth={2} />
              </div>

              {/* Title & Description */}
              <h3
                className="text-xl font-semibold mb-3"
                style={{ color: '#08005f' }}
              >
                {item.title}
              </h3>
              <p className="text-text-secondary mb-6">{item.desc}</p>

              {/* Button */}
              <Button
                variant={item.btn.variant}
                onClick={item.action}
                className={
                  item.btn.variant === 'default'
                    ? 'bg-[#08005f] hover:bg-[#eb2227] border-none text-white'
                    : 'border-[#08005f] text-[#08005f] hover:bg-[#eb2227] hover:text-white'
                }
              >
                {item.btn.text}
              </Button>
            </div>
          ))}
        </div>

        {/* Office Hours */}
        <div className="bg-[#f5f6fa] rounded-2xl p-8 max-w-lg mx-auto text-center border border-[#08005f] border-opacity-10">
          <div className="flex items-center justify-center mb-4">
            <Icon name="Clock" size={22} color="#08005f" strokeWidth={2} className="mr-2" />
            <span className="text-[#08005f] font-medium">Office Hours</span>
          </div>
          <div className="text-black space-y-1">
            <p>Monday - Friday: 8:30 AM - 5:00 PM</p>
            <p>Saturday: 8:30 AM - 1:00 PM</p>
            <p>Sunday: Closed</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
